<!-- Standalone Badge -->
@if (standalone) {
<span [class]="computedBadgeClasses()" [attr.aria-label]="ariaLabel">
  <span class="relative z-10">
    @if (content !== undefined) {
    {{ displayContent }}
    } @else {
    <ng-content></ng-content>
    }
  </span>

  <!-- Glass shimmer effect -->
  <div
    class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
    <div class="absolute inset-0 bg-linear-to-r from-transparent via-white/30 to-transparent
                      transform -skew-x-12 -translate-x-full hover:translate-x-full
                      transition-transform duration-1000 ease-out"></div>
  </div>

  <!-- Premium floating particles -->
  @if (variant === 'premium') {
  <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-40 rounded-full">
    <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse"></div>
    <div class="absolute bottom-1/3 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500"></div>
  </div>
  }

  <!-- Pulse animation for notifications -->
  @if (pulse) {
  <div class="absolute inset-0 rounded-full bg-current opacity-75 animate-ping"></div>
  }
</span>
}

<!-- Badge with Content -->
@if (!standalone) {
<div [class]="computedContainerClasses()">
  <!-- Content (what the badge is attached to) -->
  <ng-content></ng-content>

  <!-- Badge -->
  @if (showBadge) {
  <span class="badge" [class]="computedBadgeClasses()" [attr.aria-label]="ariaLabel">
    <span class="relative z-10">
      {{ displayContent }}
    </span>

    <!-- Glass shimmer effect -->
    <div
      class="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-500 pointer-events-none overflow-hidden rounded-full">
      <div class="absolute inset-0 bg-linear-to-r from-transparent via-white/30 to-transparent
                          transform -skew-x-12 -translate-x-full hover:translate-x-full
                          transition-transform duration-1000 ease-out"></div>
    </div>

    <!-- Premium floating particles -->
    @if (variant === 'premium') {
    <div class="absolute inset-0 overflow-hidden pointer-events-none opacity-40 rounded-full">
      <div class="absolute top-1/4 left-1/4 w-0.5 h-0.5 bg-white/60 rounded-full animate-pulse"></div>
      <div class="absolute bottom-1/3 right-1/4 w-0.5 h-0.5 bg-white/40 rounded-full animate-pulse delay-500"></div>
    </div>
    }

    <!-- Pulse animation for notifications -->
    @if (pulse) {
    <div class="absolute inset-0 rounded-full bg-current opacity-75 animate-ping"></div>
    }
  </span>
  }
</div>
}